// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24O_T","left":"styles_left__C0Le8"};